import React from "react"
import { Link } from "gatsby"
import { Utterences } from "./comment"

import "./index.scss"

const maxLengthOfTitle = 20

export const PostFooter = ({ pageContext, utterances }) => {
  const { previous, next } = pageContext

  const getTitle = (title) => {
    if (title.length >= maxLengthOfTitle)
      title = title.slice(0, maxLengthOfTitle) + "..."
    return title
  }

  return (
    <div>
      <ul className="navigator">
        <li>
          {previous && (
            <Link to={previous.fields.slug} rel="prev">
              ← {getTitle(previous.frontmatter.title)}
            </Link>
          )}
        </li>
        <li>
          {next && (
            <Link to={next.fields.slug} rel="next">
              {getTitle(next.frontmatter.title)} →
            </Link>
          )}
        </li>
      </ul>
      <Utterences repo={utterances}></Utterences>
    </div>
  )
}